import MfaSetup from '../../views/MfaSetup.vue';
export default [
  {
    path: '/mfa-setup',
    name: 'MfaSetup',
    component: MfaSetup
  }
];